module.exports = __webpack_public_path__ + "static/media/minus-white.b657c6ff.svg";